import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";

export interface LeaderboardEntry {
  rank: number;
  username: string;
  score: number;
  user_id: string;
  country?: string;
}

export interface LeaderboardData {
  season: number;
  remaining_days: number;
  entries: LeaderboardEntry[];
  current_user_entry?: LeaderboardEntry;
}

/**
 * Fetches leaderboard rankings
 */
export const getLeaderboard = async (
  accessToken: string,
): Promise<ServiceResponse<LeaderboardData>> => {
  try {
    const response = await fetchWithAuth("/leaderboard", accessToken);
    const data = (await response.json()) as ServiceResponse<LeaderboardData>;
    return data;
  } catch (error) {
    console.error(error);
    return {
      ok: false,
      message: "Failed to fetch leaderboard",
    };
  }
};
